"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHomeLatestActivity = void 0;
var client_1 = require("@apollo/client");
var use_entities_1 = require("./use-entities");
var lodash_1 = require("lodash");
var graphql_1 = require("../utils/graphql");
var HOME_LATEST_ACTIVITY_QUERY = (0, graphql_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query HomeLatestActivity($input: PlatformActivityInput) {\n    platformActivity(input: $input) {\n      meta {\n        count\n        total\n      }\n      results {\n        id action date\n        person { ...EntityValueFields }\n        # comments {\n        #   id name slug created isWriteable description { id text html }\n        #   createdBy { ...EntityValueFields }\n        #   replies { id name slug isWriteable created description { id text html }\n        #     createdBy { ...EntityValueFields }\n        #   }\n        # }\n        entity {\n          ...EntityValueFields\n          isPublished\n          isDraft\n          _entityTypeName\n        }\n      }\n    }\n  }\n"], ["\n  query HomeLatestActivity($input: PlatformActivityInput) {\n    platformActivity(input: $input) {\n      meta {\n        count\n        total\n      }\n      results {\n        id action date\n        person { ...EntityValueFields }\n        # comments {\n        #   id name slug created isWriteable description { id text html }\n        #   createdBy { ...EntityValueFields }\n        #   replies { id name slug isWriteable created description { id text html }\n        #     createdBy { ...EntityValueFields }\n        #   }\n        # }\n        entity {\n          ...EntityValueFields\n          isPublished\n          isDraft\n          _entityTypeName\n        }\n      }\n    }\n  }\n"])));
var useHomeLatestActivity = function (input) {
  var entities = (0, use_entities_1.useEntities)();
  var inputToUse = __assign({
    limit: 2,
    entityTypeNames: (0, lodash_1.keys)((0, lodash_1.pickBy)(entities, function (defn) {
      return defn.includeInSearch;
    }))
  }, input || {});
  var variables = {
    input: inputToUse
  };
  var _a = (0, client_1.useQuery)(HOME_LATEST_ACTIVITY_QUERY, {
      variables: variables
    }),
    data = _a.data,
    loading = _a.loading;
  var items = data && data.platformActivity && data.platformActivity.results || [];
  return {
    loading: loading,
    items: items
  };
};
exports.useHomeLatestActivity = useHomeLatestActivity;
var templateObject_1;